/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Action, ActionCreators, UserPayload } from './actions';

export interface State {
  readonly user?: UserPayload;
}

export const initialSessionState: State = {
  user: undefined,
};

export default function reducer(state: State = initialSessionState, action: Action): State {
  let partialState: Partial<State> | undefined;

  if (action.type === ActionCreators.ReceiveInitApp.type) {
    partialState = {
      user: action.payload,
    };

    return { ...state, ...partialState };
  } else {
    return state;
  }
}
